import React from "react";
import IconPlus from "../../common/icons/IconPlus";
import IconChatBot from "../../common/icons/IconChatBot";
import IconArrowLeftOne from "../../common/icons/IconArrowLeftOne";
import IconOpenSidebar from "../../common/icons/IconOpenSidebar";

const FadeHeader = ({
  showButton,
  setShowButton,
  isOpen,
  toggleSidebar,
  handleNewDiscussion,
}) => {
  setTimeout(() => {
    setShowButton(true);
  }, 500);

  return (
    <>
      {!isOpen && showButton && (
        <div className={`header-open`}>
          {!isOpen && (
            <button className="discussion-btn" onClick={handleNewDiscussion}>
              <IconPlus />
            </button>
          )}
          <div className="logo-hide-history">
            <IconChatBot />
            <h3 className="fade-h3">
              Chat AI<span className="span-beta">Beta</span>{" "}
            </h3>
          </div>
          <button className="toggle-btn-open" onClick={toggleSidebar}>
            <span className="desktop-sidebar-icon">
              <IconArrowLeftOne />
            </span>
            <span className="mobile-sidebar-icon">
              <IconOpenSidebar />
            </span>
          </button>
        </div>
      )}
    </>
  );
};

export default FadeHeader;
